import { useState, useEffect } from "react";
import { Input } from "@material-tailwind/react";
import { openNativePicker } from "./openNativePicker";

export interface MonthSelectData {
  value: string; // Format: "yyyy-MM"
}

interface MonthSelectProps {
  onChange: (data: MonthSelectData) => void;
  initialData: MonthSelectData;
}

/**
* MonthSelect: Component to select month only
* @param onChange - Callback when month changes
* @param initialData - Initial month data
*/
export default function MonthSelect({ onChange, initialData }: MonthSelectProps) {
  const [selectedMonth, setSelectedMonth] = useState(initialData.value);

  useEffect(() => {
    onChange({ value: selectedMonth });
  }, [selectedMonth, onChange]);

  const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMonth(e.target.value);
  };

  return (
    <div className="flex flex-col gap-2">
      <Input
        type="month"
        value={selectedMonth}
        onClick={openNativePicker}
        onChange={handleMonthChange}
        className="bg-white shadow-none"
        labelProps={{
          className: "hidden",
        }}
        containerProps={{ className: "min-w-[200px]" }}
      />
    </div>
  );
} 